

import { toast } from '@/utils/global';
import { ref } from "vue";
import { useGlobalData } from "@/utils/useGlobal";

const { isPc, config } = useGlobalData()

export const isShowWxPop = ref(false)
export const isShowCustomerServicePop = ref(false)
export function showSocialPop(type: string) {
  const url = config.value.socialMedia[type]
  if (type === "customer-service") {
    if (config.value.serviceUrl) {
      isShowCustomerServicePop.value = true
    } else {
      toast('敬请期待~', 1000)
    }
    return;
  }
  if (!url && type !== "weinxi") {
    toast('敬请期待~', 1000)
    return;
  }
  if (type === "weixin") {
    isShowWxPop.value = true;
    return;
  }
  if (isPc.value) {
    window.open(url, '', `width=1000,height=700,top=${(window.screen.height - 700) / 2},left=${(window.screen.width - 1000) / 2}`)
  } else {
    window.location.href = url
  }
}

export function close() {
  isShowWxPop.value = false;
}

export function closeCustomerServicePop() {
  console.log("closeCustomerServicePop")
  isShowCustomerServicePop.value = false;
}

